import { Pill } from 'ui-components/components/pill';
import { FlexRow } from 'ui-components/components/flex/row';
import { Gap } from 'ui-components/components/flex/gap';
import type { ReactNode } from 'react';

import style from './premium-tag-shell.module.css';

type PremiumTagShellProps = {
  color: string;
  logo: ReactNode;
  children: ReactNode;
};

export const PremiumTagShell = ({ color, logo, children }: PremiumTagShellProps) => {
  return (
    <Pill
      color={color}
      label={
        <FlexRow className={style['tag-label']} gap={Gap.Space8}>
          {logo}
          {children}
        </FlexRow>
      }
      theme='tag'
    />
  );
};
